module.exports = __webpack_public_path__ + "media/Prompt_Generation.912ec15e.webm";